import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { ToggleButton } from 'wix-rich-content-toolbars-ui';
import DesignIcon from '../assets/icons/DesignIcon.js';

const PollDesignButton = ({ toolbarItem, dataHook }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: DesignIcon,
      onClick: () => {
        var _a;
        return (_a = toolbarItem.commands) == null ? void 0 : _a.click({ isMobile });
      },
      dataHook,
      tooltip: t("Poll_PollSettings_Tab_Design_TabName")
    }
  );
};

export { PollDesignButton };
//# sourceMappingURL=PollDesignButton.js.map
